/**
 * Static metadata for ECA node types (label, class, classColor).
 * Field-level descriptions are provided by the backend configSchema (field.description)
 * and no longer duplicated here, except for gateway fields which have no backend equivalent.
 */
export const NODE_TYPE_DOCS = {
  event:     { label: 'Event',     class: 'standard', classColor: 'blue',  fields: {} },
  action:    { label: 'Action',    class: 'standard', classColor: 'blue',  fields: {} },
  condition: { label: 'Condition', class: 'standard', classColor: 'blue',  fields: {} },

  gateway: {
    label: 'Gateway',
    class: 'flow',
    classColor: 'rose',
    fields: {
      reset_after_fire: {
        label: 'Reset after fire',
        doc: 'OFF (default): the node fires once per session and ignores further branch notifications — safe for linear workflows. ' +
          'ON: after firing, all branches reset to pending so the node can fire again in the same session — required for loop patterns.',
      },
    },
  },
};

/** Returns the doc string for a given node type and field key, or a fallback. */
export const getFieldDoc = (nodeType, fieldKey) => {
  return NODE_TYPE_DOCS[nodeType]?.fields?.[fieldKey]?.doc ?? null;
};
